import { ToastrState } from 'react-redux-toastr';
import { applyMiddleware, compose, createStore, Store } from 'redux';
import { persistStore } from 'redux-persist';
import createSagaMiddleware from 'redux-saga';
import { AppControllersState } from './ducks/appControllers/types';
import { AuthState } from './ducks/auth/types';
import { CommonState } from './ducks/common/types';
import { contactDPOState } from './ducks/contactDPO/types';
import { CriacaoAssuntoState } from './ducks/CriacaoDosAssuntosDeContato/types';
import { DocumentState } from './ducks/document/types';
import { HistoricoState } from './ducks/ExibirHistoricoDeManutencaoDasAtividades/types';
import { LanguageState } from './ducks/language/types';
import { ListaAuditoriaState } from './ducks/ListaAuditoria/types';
import { AtividadesState } from './ducks/ManterAtividadesTratamentoDados/types';
import rootSaga from './ducks/rooSaga';
import rootReducer from './ducks/rootReducer';
import { ThemeState } from './ducks/theme/types';
import { UserState } from './ducks/user/types';
import { PersonalState } from './ducks/VisualizarDadosDosTitulares/types';
import persistReducers from './persistReducer';

export interface ApplicationState {
  auth: AuthState;
  appControllers: AppControllersState;
  user: UserState;
  language: LanguageState;
  contactDPO: contactDPOState;
  theme: ThemeState;
  ManterAtividadesTratamentoDados: AtividadesState;
  ExibirHistoricoDeManutencaoDasAtividades: HistoricoState;
  criacaoAssunto: CriacaoAssuntoState;
  listaAuditoria: ListaAuditoriaState;
  VisualizarDadosDosTitulares: PersonalState;
  document: DocumentState;
  common: CommonState;
  toastr: ToastrState;
}

const sagaMonitor =
  process.env.NODE_ENV === 'development'
    ? // @ts-ignore
      // @ts-ignore
      console.tron.createSagaMonitor()
    : null;
const middlewares = [];
const sagaMiddleware = createSagaMiddleware({
  sagaMonitor,
});
middlewares.push(sagaMiddleware);

const composer =
  process.env.NODE_ENV === 'development'
    ? compose(
        applyMiddleware(...middlewares),
        // @ts-ignore
        console.tron.createEnhancer(),
      )
    : applyMiddleware(...middlewares);

//@ts-ignore
const store: Store<ApplicationState> = createStore(
  persistReducers(rootReducer),
  composer,
);

const persistor = persistStore(store);

sagaMiddleware.run(rootSaga);

export { store, persistor };
